// extracted by mini-css-extract-plugin
export default {"filter":"Filter_filter__asygT","menu_filter":"Filter_menu_filter__k0d1q","title":"Filter_title__7iS2q","filter_box":"Filter_filter_box__llro4"};